/* Product page (mobile) title auto-fit: no ellipsis, one line */
console.log('[title-fit] loaded');
(function () {
  function fitOnce(el, maxPx, minPx, stepPx) {
    el.style.fontSize = maxPx + 'px';
    el.style.whiteSpace = 'nowrap';
    let current = maxPx, guard = 0;
    while (el.scrollWidth > el.clientWidth && current > minPx && guard < 40) {
      current -= stepPx;
      el.style.fontSize = current + 'px';
      guard++;
    }
  }
  function run() {
    if (window.innerWidth > 749) return; // 모바일만
    // 이 테마는 data-section-type="product" 존재
    const isProduct = document.querySelector('[data-section-type="product"]');
    if (!isProduct) return;

    const nodes = document.querySelectorAll(
      'h1.product__title, .product__title .h1, .product-title, h1[itemprop="name"], .product-single__title'
    );
    nodes.forEach(function (el) { fitOnce(el, 22, 16, 1); }); // 필요 시 24~15로 조정
  }
  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('resize', run);
})();
